import styled from 'styled-components'
import { setFlex } from '../../styles/themeStyles'

export const Page = styled.div`
  ${setFlex()};
  flex-direction: column;
  width: 100%;
  max-width: 480px;
  margin: auto;
  padding: 40px 20px 60px;
  text-align: center;
`

export const Label = styled.div`
  font-size: 14px;
  letter-spacing: 2px;
  text-transform: uppercase;
  opacity: 0.6;
`

export const BigNumber = styled.div`
  font-size: 72px;
  font-weight: 700;
  line-height: 1.05;
  margin: 8px 0 4px;
`

export const Headline = styled.div`
  font-size: 26px;
  font-weight: 600;
  margin-top: 8px;
`

export const Ready = styled(Headline)`
  color: #3f7a3f;
`

export const Sub = styled.div`
  font-size: 14px;
  opacity: 0.65;
  margin-top: 10px;
`

export const Chips = styled.div`
  ${setFlex()};
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 16px;
`

export const Chip = styled.div`
  padding: 8px 14px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 999px;
  font-size: 16px;
`

export const Note = styled.div`
  font-size: 13px;
  opacity: 0.6;
  margin-top: 24px;
`

export const Foot = styled.div`
  font-size: 12px;
  opacity: 0.5;
  margin-top: 28px;
`

export const LinkBtn = styled.a`
  display: inline-block;
  margin-top: 18px;
  padding: 10px 20px;
  border: 1px solid rgba(0, 0, 0, 0.25);
  border-radius: 999px;
  font-size: 15px;
`
